import { ServerEventsProviderService } from '@anecdotes/server-events';
import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { ServerEventType, User } from '../../../models';
import { UserCreatedAction, UserRemovedAction, UserUpdatedAction } from '../../actions';
import { AuthService, RoleService } from '@anecdotes/auth-core';
import { WindowHelperService, LoggerService } from '@anecdotes/utils';

@Injectable()
export class UserServerEventEffects {
  constructor(
    private serverEvents: ServerEventsProviderService,
    private roleService: RoleService,
    private authService: AuthService,
    private store: Store,
    private windowHelper: WindowHelperService,
    private logger: LoggerService,
  ) {}

  userAdded$ = createEffect(
    () =>
      this.serverEvents.getServerEvent(ServerEventType.UserAdded).pipe(
        tap((message) => {
          this.store.dispatch(
            new UserCreatedAction({
              uid: message.message_object.uid,
              audit_id: message.message_object.audit_id,
              email: message.message_object.email,
              first_name: message.message_object.first_name,
              last_name: message.message_object.last_name,
              role: message.message_object.role,
              status: message.message_object.status,
              email_login_disabled: message.message_object.email_login_disabled
            })
          );
        })
      ),
    { dispatch: false }
  );

  userDeleted$ = createEffect(
    () =>
      this.serverEvents.getServerEvent(ServerEventType.UserDeleted).pipe(
        tap((message) => {
          this.store.dispatch(new UserRemovedAction({ email: message.message_object.user_email }));
        })
      ),
    { dispatch: false }
  );

  userUpdated$ = createEffect(
    () =>
      this.serverEvents.getServerEvent(ServerEventType.UserUpdated).pipe(
        tap((serverEvent) => {
          this.logger.log({
            ServerEventMessage: serverEvent,
          });
        }),
        mergeMap(async (message) => {
          const updatedUser = message.message_object as User;
          const currentUser = await this.authService.getUserAsync();
          const roleWrapped = await firstValueFrom(this.roleService.getCurrentUserRole());

          if (updatedUser.uid === currentUser.user_id && roleWrapped.role !== updatedUser.role) {
            await this.authService.refreshToken();
            this.windowHelper.redirectToOrigin();
          } else {
            this.store.dispatch(new UserUpdatedAction(updatedUser));
          }
        })
      ),
    { dispatch: false }
  );
}
